import axios from "axios";
export const client = axios.create({});

// Add a request interceptor
client.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
client.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

/**
 * Request Wrapper with default success/error actions
 */
const request = function (options) {
  const onSuccess = function (response) {
    console.log("Request Successful!", response);
    console.log(response.data);
    console.log(response.status);
    console.log(response.statusText);
    console.log(response.headers);
    console.log(response.config);
    return response.data;
  };

  const onError = function (error) {
    console.error("Request Failed:", error.config);

    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
      console.error("Headers:", error.response.headers);
    } else {
      console.error("Error Message:", error.message);
    }

    return Promise.reject(error.response || error.message);
  };

  return client(options).then(onSuccess).catch(onError);
};

export const GetAPIRequest = (options) => {
  return request({
    method: "GET",
    ...options,
  });
};
export const PostAPIRequest = (options) => {
  return request({
    method: "POST",
    ...options,
  });
};
export const PutAPIRequest = (options) => {
  return request({
    method: "PUT",
    ...options,
  });
};
export const DeleteAPIRequest = (options) => {
  return request({
    method: "DELETE",
    ...options,
  });
};
export const MultipleGetRequest = (options) => {
  if (options && options.URL1 && options.URL2) {
    axios
      .all([axios.get(options.URL1), axios.get(options.URL2)])
      .then((responseArr) => {
        console.log("Request Successful!", responseArr);
        return responseArr;
      })
      .catch((error) => {
        console.error("Request Failed:", error.config);
        if (error.response) {
          console.error("Status:", error.response.status);
          console.error("Data:", error.response.data);
          console.error("Headers:", error.response.headers);
        } else {
          console.error("Error Message:", error.message);
        }
        return Promise.reject(error.response || error.message);
      });
  }
};

export default request;
